// ./Components/RateRequestCard/RateRequestCard.js
// Writing this using the React Hooks, plan transition to hooks throughout the application.
// For testing to return a quote from the API: check the rates_history table and set rate_declined to N OR carrier_finalprice to null & in masterquotes set statusedi to "AwaitingQuotes"

import React, { useState, useEffect, useContext } from "react";
import Input01 from "../../SmallComponents/Input01";
import Input03 from "../../SmallComponents/Input03";
import SubmitQuoteResponse from "../../APIs/SubmitRateQuoteResponse";
import PickupDelDatesTimesStatic01 from "../ShipmentCard/Components/PickupDelDatesTimesStatic01_RR";
import GuaranteedDeliveryIcon from "../ShipmentCard/Components/GuaranteedDeliveryIcon";
import RateRequestSubmitAndStatus from "./Components/RateRequestSubmitAndStatus";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import Details from "./Components/Details";
import HandlingUnits from "./Components/HandlingUnits";
import Stops from "./Components/Stops";
import Arrow from "./Components/Arrow"
import ODockType from "../ShipmentCard/Components/ODockType";
import DDockType from "../ShipmentCard/Components/DDockType";
import UserContext from "../../UserDataContext";


// --- Carrier Re-Bid -------------------------------------------------------
// The v4 shipment service returns rateRequestDetails.rebidRound only while a
// re-bid round is actually open, so its presence is what identifies a re-bid.
// An ordinary rate request has none of these fields and renders exactly as it
// always has.
//
// Only the carrier's OWN previous quote is ever shown here -- no competitor
// price and no benchmark, the same rule the re-bid email follows.

// The deadline arrives already formatted for display (the v4 service formats it
// in SQL -- see buildQuery.js). Print it verbatim; do NOT parse it into a Date.
// The stored value is a naked DATETIME written from the ColdFusion server's
// clock, so building a Date from it would have it reinterpreted in the API
// container's zone and re-rendered in the viewer's, showing a time hours away
// from the one the carrier's email promised.
const rebidDeadlineText = (value) =>
  typeof value === "string" ? value.trim() : "";

const formatRebidMoney = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "";
  return number.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

// Inline rather than a stylesheet rule: this component already styles with
// inline objects (style={style}, style={{ flex: 1 }}) and there is no
// component-level CSS file to add a class to.
const rebidNoticeStyle = {
  border: "1px solid #d9a441",
  borderLeftWidth: "4px",
  background: "#fff3cd",
  color: "#8d5a00",
  padding: "10px 14px",
  margin: "0 0 10px 0",
  borderRadius: "3px",
  fontSize: "0.9rem",
  lineHeight: "1.45",
};

const RateRequestCard = (props) => {

  const { data, showFields } = props;

  const userData = useContext(UserContext);

  const [billedCost, setBilledCost] = React.useState("");
  const [fuelSurcharge, setFuelSurcharge] = React.useState("");
  const [taxes, setTaxes] = React.useState("");
  const [transitDays, setTransitDays] = React.useState("");
  const [name, setName] = React.useState(userData.name);
  const [phone, setPhone] = React.useState(userData.phone);
  const [email, setEmail] = React.useState(userData.email);
  const [rateRequestID, setRateRequestID] = React.useState("");
  const [secureID, setSecureId] = React.useState("");
  const [alertStatus, setAlertStatus] = React.useState("hide");
  const [renderForm, setRenderForm] = React.useState(false);
  const [rateExpiresDate, setRateExpiresDate] = React.useState("");
  const [oceanFreight, setOceanFreight] = useState("");
  const [drayage, setDrayage] = useState("");
  const [rail, setRail] = useState("");
  const [waitingTime, setWaitingTime] = useState("");
  const [transitTime, setTransitTime] = useState("");
  const [effectiveDate, setEffectiveDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [accessorialTotalForOcean, setAccessorialTotalForOcean] = useState(0);
  const [notes, setNotes] = useState("");
  const [emailError, setEmailError] = useState("");
  const [touched, setTouched] = useState(false);

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!validateEmail(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleEmailBlur = () => {
    setTouched(true);
  };


  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);


  // console.log('RateRequestCard', data)
  const style = {
    cursor: "pointer",
  };

  //Card header onClick
  const headerClick = () => {
    if (renderForm) {
      setRenderForm(false);
    } else {
      setRenderForm(true);
    }
  };

  const checkEmptyString = (number) => {
    if (number === "" || isNaN(number)) {
      return 0;
    } else {
      return parseFloat(number);
    }
  };


  // console.log('expiresdate ', props.showFields.includes("rateexpiresdate"))


  // Accessorials moved to state and hook + change handler for the input fields
  // Because the fields aren't static (the number of accessorials is unknown) it has to be handled differently than a static input

  let accessorials = [];
  if (data.details.accessorials) {
    const accessorialDetailsMode = true
    if (accessorialDetailsMode) {
      if (data.details?.accessorialDetails) {
        accessorials = data.details.accessorialDetails
      }
    } else {
      accessorials = data.details.accessorials
    }
  }
  const [accessorialState, setAccessorialState] = useState(accessorials);

  const handleAccessorialChange = (e) => {
    const updatedAccessorials = [...accessorialState];
    updatedAccessorials[e.target.dataset.idx][e.target.name] = e.target.value;
    setAccessorialState(updatedAccessorials);
  };




  //Add up all the accessorial costs
  const accessorialTotal = (accessorialState) => {
    let accessorialTotalVal = 0;
    accessorialState.forEach((accessorialItem) => {
      if (isNaN(parseFloat(accessorialItem.price))) {
      } else {
        accessorialTotalVal =
          parseFloat(accessorialItem.price) + accessorialTotalVal;
      }
    });
    return accessorialTotalVal;
  };

  const changeBilledCost = (value) => {
    setBilledCost(value);
    if (data.client.id.includes('halliburton')) {
      calculateFuelSurcharge(value, data.details.miles, data.rateRequestDetails.brokerCarrierId, data.consignee.address.state, data.details.totalWeight)
    }
  }

  const calculateFuelSurcharge = (total, miles, brokerCarrierId, state, billableWeight) => {
    const url = "https://api.shippersedge.com/v2/rates/fuelSurcharge";
    const key = "vdhy8wwjUJrwhxFpfuECTiAW";
    const body = {
      "total": total,
      "date": "2021-06-01",
      "carrierId": brokerCarrierId,
      "miles": miles,
      "billableWeight": billableWeight,
      "state": state
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': key
      },
      body: JSON.stringify(body)
    };
    fetch(url, requestOptions)
      .then(response => response.json())
      .then(data => {
        // console.log('FuelSurcharge', data)
        setFuelSurcharge(data.amount)
      });
  }


  // Total Cost
  let totalCost = (
    checkEmptyString(billedCost) +
    checkEmptyString(fuelSurcharge) +
    accessorialTotal(accessorialState) +
    checkEmptyString(taxes)
  ).toFixed(2);

  let totalOceanCost = (
    checkEmptyString(oceanFreight) +
    checkEmptyString(drayage) +
    checkEmptyString(rail) +
    checkEmptyString(accessorialTotalForOcean)
  ).toFixed(2);

  //Shipment updated Alert
  // const shipmentUpdatedAlert = () => {
  //   setAlertStatus("loading");
  //   setTimeout(() => setAlertStatus("show"), 2000);
  // };

  const buildFormData = (submitRateOrDeclineShipment) => {
    if (submitRateOrDeclineShipment === "declineShipment") {
      // console.log("RateRequestCard.js, fn respondToRateRequest, DECLINED!!!");
      const updateData = new FormData();
      updateData.append("rq", rateRequestID);
      updateData.append("secid", secureID);
      updateData.append("decline", "yes");
      // Debug FormData
      // console.log("RateRequest Decline FormData:");
      // for (var pair of updateData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }
      return updateData;
    } else if (isOceanInt) {
      const updateData = {};
      // Charges
      updateData.oceanFreight = oceanFreight;
      updateData.drayage = drayage;
      updateData.rail = rail;
      updateData.waitingTime = waitingTime;
      updateData.transitTime = transitTime;
      updateData.effectiveDate = effectiveDate;
      updateData.expirationDate = expirationDate;
      updateData.totalOceanCost = totalOceanCost;

      // Accessorials
      updateData.accessorialCharges = accessorialTotalForOcean

      // Completed By Input Data
      updateData.name = name;
      updateData.phone = phone;
      updateData.email = email;
      updateData.notes = notes;
      // shipment data
      updateData.rateHistId = rateRequestID;
      updateData.laneId = data.lane.id;
      updateData.carId = data.rateRequestDetails.carid;
      updateData.service_type = data.international.type;
      updateData.container_type = data.international.container;
      updateData.incoterms = data.international.incoterms;

      return updateData;
    } else {
      const updateData = new FormData();
      updateData.append("rq", rateRequestID);
      updateData.append("secid", secureID);
      updateData.append("basecost", billedCost);
      updateData.append("fuelsurcharge", fuelSurcharge);
      updateData.append("taxes", taxes);
      updateData.append("totalcost", totalCost);
      updateData.append("transtime", transitDays);
      updateData.append("tenderacceptance_name", name);
      updateData.append("tenderacceptance_phone", phone);
      updateData.append("tenderacceptance_email", email);
      if (rateExpiresDate && rateExpiresDate !== "") {
        updateData.append("rateexpiresdate", rateExpiresDate);
      }
      // Add accessorials to formData
      // updateData.append("accessorial"+ 6, 11); <-- For reference
      if (accessorialState.length) {
        accessorialState.forEach((accessorialItem) => {
          if (isNaN(parseFloat(accessorialItem.price))) {
          } else {
            updateData.append(
              "accessorial" + accessorialItem.id,
              accessorialItem.price
            );
          }
        });
      }
      // Debug FormData
      // console.log("RateRequest Accept FormData:");
      // for (var pair of updateData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }

      return updateData;
    }
  };

  useEffect(() => {
    if (props.data.rateRequestDetails?.rateRequestId) {
      setRateRequestID(props.data.rateRequestDetails.rateRequestId);
    }
  }, [props.data.rateRequestDetails]);
  useEffect(() => {
    if (props.data.rateRequestDetails?.rateRequestBrokerSecid) {
      setSecureId(props.data.rateRequestDetails.rateRequestBrokerSecid);
    }
  }, [props.data.rateRequestDetails]);

  // Set rateexpiresdate default to 1 year from today
  useEffect(() => {
    // DO NOT CALCULATE FUEL FOR KWIKTRIP PER MEGHAN 8/8/23 (this could be useful for future clients)
    if (data.client.id.includes('halliburton')) {
      calculateFuelSurcharge(data.details.totalCost, data.details.miles, data.rateRequestDetails.brokerCarrierId, data.consignee.address.state, data.details.totalWeight)
    }
    if (showFields.includes("rateexpiresdate")) {
      const today = new Date();
      const oneYearFromToday = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
      setRateExpiresDate(oneYearFromToday.toISOString().split('T')[0]);
    }
  }, []);

  const copyToClipboard = (event) => {
    if (navigator.clipboard) {
      const text = event.target.innerText;
      navigator.clipboard.writeText(text);
      // event.target.innerText = "Copied to Clipboard!";
    } else {
      console.warn("No navigator.clipboard")
    }
  };
  const isOceanInt = data.details.mode.includes('INT_OCEAN')
  let isFormValid = true;
  if (isOceanInt) {
    isFormValid = oceanFreight !== "" && effectiveDate !== "" && expirationDate !== "" && email !== "" && phone !== "";
  }

  const serviceType = {
    'pp': 'Port to Port',
    'pd': 'Port to Door',
    'dp': 'Door to Port',
    'dd': 'Door to Door',
  }
  const rebidRound = Number(data.rateRequestDetails?.rebidRound ?? 0);
  const isRebid = rebidRound > 0;
  const rebidPreviousQuote = formatRebidMoney(data.rateRequestDetails?.rebidPreviousQuote);
  const rebidExpires = rebidDeadlineText(data.rateRequestDetails?.rebidExpiresAt);

  return (
    <div className="rate-quote-cards">
      <div className="card" style={style}>
        <div className="card-header" onClick={headerClick}>
          <div className="row rr-header-row">
            <div className="col-sm-2">
              {data?.usercontrol ?
                <>
                  <span className="font-weight-bold">{userData?.userControlAbbr ?? "Load"}:</span>
                  <br />
                  {data?.usercontrol}
                  <br />
                </>
                : null
              }

              <span className="font-weight-bold">{userData.config?.labels?.webquotecontrol ?? "BOL"}:</span>
              <br />
              <span
                className="linkText"
                title="BOL number, click to copy to clipboard."
                onClick={copyToClipboard}
              >
                {data.id}
              </span>
              <br />
              {isOceanInt && (
                <>
                  <span className="font-weight-bold">Service Type:</span> <br />
                  {data.international?.type ? serviceType[data.international.type] : null}
                  <br />
                  <span className="font-weight-bold">Container Type:</span> <br />
                  {data.international?.container ? data.international.container : null}
                </>
              )}

            </div>
            <div className="col-sm-8 d-flex flex-column flex-sm-row rr-header-section">
              {/* Pickup */}
              <div style={{ flex: 1 }}>
                <span className="font-weight-bold">Initial Pickup:</span><br />
                {data.shipper.name !== "" ? data.shipper.name : null}
                {data.shipper.name !== null ? <br /> : null}
                {data.shipper.address.line1 !== "" ? data.shipper.address.line1 : null}
                {data.shipper.address.line1 !== null ? <br /> : null}
                {data.shipper.address.line2 !== "" ? data.shipper.address.line2 : null}
                {data.shipper.address.line2 !== null ? <br /> : null}
                {data.shipper.address.city}, {data.shipper.address.state}{" "}
                {data.shipper.address.zip}
                {isOceanInt && (
                  <><br />
                    <span className="font-weight-bold">Origin Port:</span><br />
                    {data.international?.originPort?.port ?? null}<br />
                    <span className="font-weight-bold">Des Port:</span><br />
                    {data.international?.destinationPort?.port ?? null}
                  </>
                )}
                <ODockType show={showFields.includes("ODockType")} shipment={data} />
                <br />
                <PickupDelDatesTimesStatic01 mode={"pickup"} shipment={data} />
              </div>

              {/* Arrow */}
              <div className="d-none d-sm-flex px-3 pt-1 flex-shrink-0">
                <Arrow shipment={data} />
              </div>

              {/* Delivery */}
              <div style={{ flex: 1 }}>
                <span className="font-weight-bold">Final Delivery:</span><br />
                {data.consignee.name !== "" ? data.consignee.name : null}
                {data.consignee.name !== null ? <br /> : null}
                {data.consignee.address.line1 !== "" ? data.consignee.address.line1 : null}
                {data.consignee.address.line1 !== null ? <br /> : null}
                {data.consignee.address.line2 !== "" ? data.consignee.address.line2 : null}
                {data.consignee.address.line2 !== null ? <br /> : null}
                {data.consignee.address.city}, {data.consignee.address.state}{" "}
                {data.consignee.address.zip}
                {isOceanInt && (
                  <><br />
                    <span className="font-weight-bold">Incoterms:</span><br />
                    {data.international?.incoterms ?? null}
                  </>
                )}
                <DDockType show={showFields.includes("DDockType")} shipment={data} />
                <br />
                <PickupDelDatesTimesStatic01 mode={"delivery"} shipment={data} />
                {showFields.includes("guaranteedDelivery") ? (
                  <GuaranteedDeliveryIcon render="show" guaranteed={data.details.guaranteed} />
                ) : null}
              </div>
            </div>

            {/* Details */}
            <div className="col-sm-2 rr-header-section">
              <Details data={data} client={data.client.id} />
            </div>
          </div>
          {/* Notes Row */}
          {data.shipper.bolNotes || data.consignee.bolNotes ? (
            <>
              <div className="row">
                <div className="col-sm-3">
                  <span className="font-weight-bold">Notes:</span>
                </div>
                <div className="col-sm-9"> {data.shipper.bolNotes} {data.consignee.bolNotes}</div>
              </div>
              <br />
            </>
          ) : null}

        </div>

        {/* Carrier Re-Bid notice. Sits outside the form body on purpose -- the
            body only renders once the card is opened (renderForm), and a
            carrier scanning a list of requests has to be able to see that this
            one is a re-bid without opening it first.

            Nothing here is a control: the carrier still responds with the
            normal Submit / Decline buttons in the form below. If the deadline
            passes with no response, their previous quote is put back on the
            shipment automatically -- which is what the last line tells them. */}
        {isRebid && (
          <div style={rebidNoticeStyle}>
            <strong>This is a re-bid request.</strong> Your previous quote was not
            the lowest we received for this load. If you would like to re-bid at a
            lower price for a chance to win the shipment, submit an updated rate
            below.
            {rebidPreviousQuote && (
              <>
                <br />
                Your previous quote: <strong>{rebidPreviousQuote}</strong>
              </>
            )}
            {rebidExpires && (
              <>
                <br />
                Open until <strong>{rebidExpires}</strong>. If we have not heard
                from you by then, your previous quote stays on file and remains in
                consideration for this shipment.
              </>
            )}
          </div>
        )}

        {/* FORM */}
        {!renderForm ? (
          <span className="condRenderDetailBodyAndFormText">
            Click the shipment to see more details / submit rates.
          </span>
        ) : (
          <div className="card-body">

            {/* Stops Row */}
            <div className="row">
              <div className="col-sm-12">
                <Stops shipment={data} />
              </div>
            </div>
            {/* Dimensions Row */}
            <div className="row">
              <div className="col-sm-12">
                <HandlingUnits shipment={data} />
              </div>
              <div className="col-sm-6">

                {/* <Items shipment={data} /> */}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <hr />
              </div>
            </div>
            <div className="row rr-form-compact">
              {/* Charges */}
              <div className="col-md-4">
                <div className="font-weight-bold mb-1">Charges:</div>
                {!isOceanInt && <>
                  <div className="rr-field-row">
                    <span className="rr-label">{data.client.id === 'kwiktrip' ? 'All-In Rate' : 'Base Charge'}:</span>
                    <div className="rr-input">
                      <Input01 name="billedCost" showHide="show" symbol="$" type="number" step="0.01" size="small" min="0" placeholder="0.00" value={billedCost} onChange={(e) => changeBilledCost(e.target.value)} />
                    </div>
                  </div>
                  {data.client.id !== 'kwiktrip' && (
                    <div className="rr-field-row">
                      <span className="rr-label">Fuel Surcharge:</span>
                      <div className="rr-input">
                        <Input01 name="fuelSurcharge" showHide="show" symbol="$" type="number" step="0.01" min="0" placeholder="0.00" size="small" value={fuelSurcharge} readOnly={data.client.id.includes('halliburton')} onChange={(e) => setFuelSurcharge(e.target.value)} />
                      </div>
                    </div>
                  )}
                  {data.client.id !== 'kwiktrip' && !data.client.id.includes('halliburton') && (
                    <div className="rr-field-row">
                      <span className="rr-label">Taxes:</span>
                      <div className="rr-input">
                        <Input01 name="taxes" showHide="show" symbol="$" type="number" step="0.01" min="0" placeholder="0.00" size="small" value={taxes} onChange={(e) => setTaxes(e.target.value)} />
                      </div>
                    </div>
                  )}
                  {data.client.id !== 'kwiktrip' && (
                    <div className="rr-field-row">
                      <span className="rr-label">Transit Days:</span>
                      <div className="rr-input">
                        <Input01 name="transitDays" showHide="show" type="number" step="1" size="small" value={transitDays} onChange={(e) => setTransitDays(e.target.value)} />
                      </div>
                    </div>
                  )}
                </>}
                {isOceanInt && <>
                  <div className="rr-field-row">
                    <span className="rr-label">Ocean Freight<span style={{ color: "red" }}>*</span>:</span>
                    <div className="rr-input">
                      <Input01 name="oceanFreight" showHide="show" symbol="$" type="number" step="1" size="small" value={oceanFreight} isRequired={true} onChange={(e) => setOceanFreight(e.target.value)} />
                    </div>
                  </div>
                  <div className="rr-field-row">
                    <span className="rr-label">Drayage:</span>
                    <div className="rr-input">
                      <Input01 name="drayage" showHide="show" symbol="$" type="number" step="1" size="small" value={drayage} onChange={(e) => setDrayage(e.target.value)} />
                    </div>
                  </div>
                  <div className="rr-field-row">
                    <span className="rr-label">Rail:</span>
                    <div className="rr-input">
                      <Input01 name="rail" showHide="show" symbol="$" type="number" step="1" size="small" value={rail} onChange={(e) => setRail(e.target.value)} />
                    </div>
                  </div>
                  <div className="rr-field-row">
                    <span className="rr-label">Waiting Time:</span>
                    <div className="rr-input">
                      <Input01 name="waitingTime" showHide="show" type="number" placeholder="0 hours" step="1" size="small" value={waitingTime} onChange={(e) => setWaitingTime(e.target.value)} />
                    </div>
                  </div>
                  <div className="rr-field-row">
                    <span className="rr-label">Transit Time:</span>
                    <div className="rr-input">
                      <Input01 name="transitTime" showHide="show" type="number" placeholder="0 hours" step="1" size="small" value={transitTime} onChange={(e) => setTransitTime(e.target.value)} />
                    </div>
                  </div>
                  <div className="rr-field-row">
                    <span className="rr-label">Effective Date<span style={{ color: "red" }}>*</span>:</span>
                    <div className="rr-input">
                      <Input01 name="effectiveDate" showHide="show" type="date" step="1" size="small" value={effectiveDate} isRequired={true} onChange={(e) => setEffectiveDate(e.target.value)} />
                    </div>
                  </div>
                  <div className="rr-field-row">
                    <span className="rr-label">Expiration Date<span style={{ color: "red" }}>*</span>:</span>
                    <div className="rr-input">
                      <Input01 name="expirationDate" showHide="show" type="date" step="1" size="small" value={expirationDate} isRequired={true} onChange={(e) => setExpirationDate(e.target.value)} />
                    </div>
                  </div>
                </>}
                {showFields.includes("rateexpiresdate") && (
                  <div className="rr-field-row">
                    <span className="rr-label">Rate Expires:</span>
                    <div className="rr-input">
                      <Input01 name="rateexpiresdate" showHide="show" type="date" size="small" value={rateExpiresDate} onChange={(e) => setRateExpiresDate(e.target.value)} />
                    </div>
                  </div>
                )}
                <div className="mt-1"><strong>Total: ${!isOceanInt ? totalCost : totalOceanCost}</strong></div>
              </div>

              {/* Accessorials - regular */}
              {data.client.id !== 'kwiktrip' && !isOceanInt && accessorialState.length ? (
                <div className="col-md-4 rr-form-section">
                  <div className="font-weight-bold mb-1">Accessorials:</div>
                  {accessorialState.map((val, idx) => (
                    <div className="rr-field-row" key={`accessorial-${idx}`}>
                      <span className="rr-label">{val.formDisplay}</span>
                      <div className="rr-input">
                        <Input03 idx={idx} accessorialState={accessorialState} handleAccessorialChange={handleAccessorialChange} accessorialName={val.accessorialName} symbol="$" />
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}

              {/* Accessorials - ocean */}
              {isOceanInt && (
                <div className="col-md-4 rr-form-section">
                  <div className="font-weight-bold mb-1">Accessorials:</div>
                  <div className="rr-field-row">
                    <span className="rr-label">Total:</span>
                    <div className="rr-input">
                      <Input01 name="accessorialTotal" showHide="show" symbol="$" type="number" size="small" value={accessorialTotalForOcean} onChange={(e) => setAccessorialTotalForOcean(e.target.value)} />
                    </div>
                  </div>
                  <div className="font-weight-bold mb-1 mt-1">Notes:</div>
                  <div className="rr-field-row">
                    <span className="rr-label">Carrier Notes:</span>
                    <div className="rr-input">
                      <Input01 name="notes" showHide="show" type="text" size="small" value={notes} onChange={(e) => setNotes(e.target.value)} />
                    </div>
                  </div>
                </div>
              )}

              {/* Completed By */}
              <div className="col-md-4 rr-form-section">
                <div className="font-weight-bold mb-1">Completed By:</div>
                <div className="rr-field-row">
                  <span className="rr-label">Name<span style={{ color: "red" }}>*</span>:</span>
                  <div className="rr-input">
                    <Input01 name="name" showHide="show" type="text" size="small" value={name} isRequired={true} onChange={(e) => setName(e.target.value)} />
                  </div>
                </div>
                <div className="rr-field-row">
                  <span className="rr-label">Phone<span style={{ color: "red" }}>*</span>:</span>
                  <div className="rr-input">
                    <Input01 name="phone" showHide="show" type="tel" size="small" value={phone} isRequired={true} onChange={(e) => setPhone(e.target.value)} onBlur={(e) => setPhone(e.target.value)} />
                  </div>
                </div>
                <div className="rr-field-row">
                  <span className="rr-label">E-mail<span style={{ color: "red" }}>*</span>:</span>
                  <div className="rr-input">
                    <Input01 name="email" showHide="show" type="email" size="small" value={email} isRequired={true} onChange={handleEmailChange} onBlur={handleEmailBlur} />
                  </div>
                </div>
                {touched && emailError && <div style={{ color: "red", fontSize: "0.8rem", marginBottom: "2px" }}>{emailError}</div>}
                <div className="d-flex justify-content-between mt-1">
                  <RateRequestSubmitAndStatus
                    Action={"submitRate"}
                    SubmitQuoteResponse={SubmitQuoteResponse}
                    buildFormData={buildFormData}
                    isOceanInt={isOceanInt}
                    isDisabled={!isFormValid}
                  />
                  <div className="ml-2">
                    <RateRequestSubmitAndStatus
                      Action={"declineShipment"}
                      SubmitQuoteResponse={SubmitQuoteResponse}
                      buildFormData={buildFormData}
                      isOceanInt={isOceanInt}
                    />
                  </div>
                </div>
                {isOceanInt && (
                  <>
                    <Modal show={showModal} onHide={handleCloseModal}>
                      <Modal.Header closeButton>
                        <Modal.Title>Quote Requirements</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <ul>
                          <li>Equipment type: 40'HQ</li>
                          <li>Incoterm: FCA On Board Vessel</li>
                          <li>Montreal, Brampton, Calgary and Vancouver are all 24-hour chassis drop and Belleville is 4 hours' free unload</li>
                          <li>Please list all the accessorials/additional charges (i.e. GRI, PSS, EIS, local port/rail surcharges) in the notes and specify if it is included in ocean freight</li>
                          <li>Any charges prior to "onboard" are to the account of the seller and need not be included. (i.e. E-Man/ACI to the account of shipper)</li>
                          <li>We do not pay handling fees from Asia and South East Asia</li>
                          <li>Fuel must be included in drayage and ocean freight</li>
                          <li>All Canadian services should be quoted in Canadian funds and if converted to USD please advise the exchange rate</li>
                          <li>Our payment will be issued based on the quotation and no additional charges will be accepted once the rate is confirmed unless previous approved in writing by SCC</li>
                          <li>Please noted the service provider will be excluded from the bid list if they do not complete the entire above matrix</li>
                          <li>We will not accept emails/phone calls until full submission has been received</li>
                        </ul>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <button className="btn btn-outline-info mt-2" onClick={handleShowModal}>
                      Quote Requirements
                    </button>
                  </>
                )}
              </div>

              {/* Important Notes */}
              {data?.rateRequestDetails?.brokerRemarks && data.rateRequestDetails.brokerRemarks !== "" ? (
                <div className="col-sm-12 mt-3">
                  <div className="card">
                    <div className="card-header">
                      <strong>Important Notes</strong>
                    </div>
                    <div className="card-body">
                      <p className="card-text">{data.rateRequestDetails.brokerRemarks}</p>
                    </div>
                  </div>
                </div>
              ) : null}

            </div>
          </div>
        )}
      </div>
      <br />
    </div>
  );
};

export default RateRequestCard;
